<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="topup-back">
          <div v-if="isLoading" class="loading">
            <loader />
            <div v-html="$t('view.unregister.loading')"></div>
          </div>
          <div v-if="!isLoading">
            <div>
              <div class="text" v-if="isStatusUnsubscribe">
                <h1 v-html="$t('view.unregister.title1ok')"></h1>
                <p v-html="$t('view.unregister.title2ok')"></p>
              </div>
              <div class="text" v-if="!isStatusUnsubscribe">
                <h1 v-html="$t('view.unregister.title1error')"></h1>
                <p v-html="$t('view.unregister.title1error')"></p>
              </div>
              <div class="button">
                <button type="button" class="primary" @click="goToTopup">{{ $t('view.unregister.buttonTopup') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/orange/components/Loader'
import UnsubscribeMixin from '@/common/mixins/views/Unsubscribe.mixin'
import { ROUTING } from '@/orange/const/routing.const'

export default {
  name: 'Unregister',
  components: {
    Loader
  },
  mixins: [UnsubscribeMixin],
  methods: {
    goToTopup () {
      this.$router.push(ROUTING.topup.single.step1)
    }
  }
}
</script>

<style src="../assets/scss/back.scss" lang="scss" scoped></style>
